import shared from './shared';

/**
 * Sets up Billing Classic Mirage Scenario
 * - `MIRAGE_SCENARIO='billing-classic' yarn start:mirage`
 *
 * @param {Object} server Mirage Server
 */
export default function (server) {
  const {
    company,
    locations: [SFLocation, NYLocation],
  } = shared(server);

  company.update({
    planIntent: 'premium',
  });

  const vrSubscription = server.create('subscription', 'asVisitorsPremium', {
    companyId: company.id,
  });

  const deliveriesSubscription = server.create('subscription', 'asDeliveriesStandard', {
    companyId: company.id,
    isManual: false,
  });

  const paymentSource = server.create('payment-source', { brand: 'Visa', last4: '1234', companyId: company.id });

  server.createList('plan', 11);
  server.createList('subscription-plan', 29).forEach((subscriptionPlan) => {
    subscriptionPlan.update({
      alternateId: subscriptionPlan.tempAlternateId,
    });
  });

  server.create('feature', {
    company_id: company.id,
    features: [],
  });

  server.db.companies.update(company.id, {
    subscriptionId: vrSubscription.id,
    deliveriesSubscriptionId: deliveriesSubscription.id,
  });

  return {
    company,
    subscriptions: [vrSubscription, deliveriesSubscription],
    locations: [SFLocation, NYLocation],
    paymentSource,
  };
}
